import { Box, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { languageOptionMap } from 'lib/util/i18nHelpers';
import { ReduxState } from 'ducks';

import styles from './LanguageLinkBar.module.css';

export const LanguageLinkBar = () => {
  const { i18n } = useTranslation();
  const settings = useSelector((state: ReduxState) => state.server.settings.all);
  const availableLanguages = settings.supported_languages ?? [];

  return (
    <Box mt={2} display="flex" justifyContent="center">
      {availableLanguages.length > 1 && (
        <ul className={styles['language-list']}>
          {availableLanguages.map((lang) => (
            <li key={lang}>
              {languageOptionMap[lang]?.iso === i18n.language ? (
                <Typography style={{ fontWeight: 'bold' }}>
                  {languageOptionMap[lang]?.name}
                </Typography>
              ) : (
                <a
                  onClick={() => {
                    i18n.changeLanguage(languageOptionMap[lang]?.iso);
                  }}
                >
                  <Typography color="primary">{languageOptionMap[lang]?.name}</Typography>
                </a>
              )}
            </li>
          ))}
        </ul>
      )}
    </Box>
  );
};
